import { IForm } from '@/components/types'
import {
  useSearchDateShortcut,
  useSearchDuration,
  useSearchDays
} from '@/hooks/useSearch'
const shortcuts = useSearchDateShortcut()
const durationOptions = useSearchDuration()
const daysOptions = useSearchDays()

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'channelId',
      type: 'select',
      label: '直播间',
      clearable: true,
      placeholder: '请选择直播间'
    },
    {
      field: 'accessTime',
      type: 'dateTimePicker',
      label: '访问时间',
      otherOptions: {
        startPlaceholder: '开始时间',
        endPlaceholder: '结束时间',
        disabledDate: (date: Date) => {
          return new Date() < date
        },
        shortcuts: shortcuts
      }
    },
    {
      field: 'duration',
      type: 'select',
      label: '访问时长',
      placeholder: '请选择访问时长',
      options: durationOptions,
      clearable: true
    },
    {
      label: '持续听课且未成交',
      type: 'select',
      field: 'continueAttend',
      placeholder: '请选择天数',
      options: daysOptions,
      clearable: true
    }
  ]
}
